export const XsensUSACountries = [
  "AI", // Anguilla
  "AG", // Antigua and Barbuda
  "AR", // Argentina
  "AW", // Aruba
  "BS", // Bahamas
  "BB", // Barbados
  "BZ", // Belize
  "BM", // Bermuda
  "BO", // Bolivia, Plurinational State of
  "BQ", // Bonaire, Sint Eustatius and Saba
  "BR", // Brazil
  "CA", // Canada
  "KY", // Cayman Islands
  "CL", // Chile
  "CO", // Colombia
  "CR", // Costa Rica
  "CU", // Cuba
  "CW", // Curaçao
  "DM", // Dominica
  "DO", // Dominican Republic
  "EC", // Ecuador
  "SV", // El Salvador
  "FK", // Falkland Islands (Malvinas)
  "GF", // French Guiana
  "GD", // Grenada
  "GP", // Guadeloupe
  "GT", // Guatemala
  "GY", // Guyana
  "HT", // Haiti
  "HN", // Honduras
  "JM", // Jamaica
  "MQ", // Martinique
  "MX", // Mexico
  "MS", // Montserrat
  "NI", // Nicaragua
  "PA", // Panama
  "PY", // Paraguay
  "PE", // Peru
  "BL", // Saint Barthélemy
  "KN", // Saint Kitts and Nevis
  "LC", // Saint Lucia
  "MF", // Saint Martin (French part)
  "PM", // Saint Pierre and Miquelon
  "VC", // Saint Vincent and the Grenadines
  "SX", // Sint Maarten (Dutch part)
  "GS", // South Georgia and the South Sandwich Islands
  "SR", // Suriname
  "TT", // Trinidad and Tobago
  "TC", // Turks and Caicos Islands
  "US", // United States
  "UY", // Uruguay
  "VE", // Venezuela, Bolivarian Republic of
  "VG" // Virgin Islands, British
];
